export default __webpack_public_path__ + "static/media/34708.c499bbc3.jpg";